module.exports = __webpack_public_path__ + "static/slide3-e85455bdbeeab84ea3d424de6f272737.png";